/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Reason_From_Stocktake_ShortageInputs */

const vi_pl_reason_from_stocktake_shortage = /** @type {(inputs: Pl_Reason_From_Stocktake_ShortageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm kê thiếu`)
};

/**

* @param {Pl_Reason_From_Stocktake_ShortageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_reason_from_stocktake_shortage = /** @type {((inputs?: Pl_Reason_From_Stocktake_ShortageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Reason_From_Stocktake_ShortageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_reason_from_stocktake_shortage(inputs)
});